import Layout from '@/layout/layout';
import { Outlet } from 'react-router';

const PrivateLayout = () => {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default PrivateLayout;
